import { useEffect, useState } from "react"
import { CompositionEditor } from "./CompositionEditor"
import { Modal } from "antd"

interface EditCompositionModalProps {
  trigger: any
  value?: number[]
  setName?: string
  onChange?: (value: number[]) => void
}
export const EditCompositionModal = (props: EditCompositionModalProps) => {
  const {trigger, setName, value: initVal = [], onChange} = props
  const [value, setValue] = useState(initVal)
  const [show, setShow] = useState(false)

  useEffect(() => {
    setValue(initVal)
  }, [initVal])

  const saveChanges = () => {
    onChange?.(value)
    cancel()
  }

  const cancel = () => {
    setShow(false)
  }

  return <>
    <div onClick={() => setShow(true)} style={{cursor: 'pointer'}}>
      {trigger}
    </div>
    {show && <Modal open={true} title="Edit Composition" footer={null} onCancel={cancel}>
      <CompositionEditor
        readonly={false}
        setName={setName}
        value={value}
        onChange={(val) => setValue(val)}
        onSave={saveChanges}
        onCancel={cancel}
      />
    </Modal>}
  </>
}